module.exports = __webpack_public_path__ + "static/media/universityul.491a291b.png";